WiseMetering.Views.MapSearch = Backbone.Marionette.ItemView.extend({
    MAX_RESULTS: 10,
    events: {
        'keyup input': 'search',
        'click .sites-table': 'navigate',
        'click .result': 'navigate'
    },
    template: 'templates/ui/map/search',
    timeout: null,
    ui: {
        sitesTable: '.sites-table',
        results: '.results',
        searchBox: 'input',
        searchIcon: '.icon-searching',
        searchSummary: '.search-summary'
    },

    navigate: function(event) {
        Backbone.history.navigate(event.currentTarget.dataset.href, { trigger: true });
    },

    onShow: function() {
        window.MapService.events.on('map:search:end', this.showResults.bind(this));
        this.search();
        this.showResults();
    },

    search: function() {
        const query = this.ui.searchBox.val() || '';
        this.ui.searchSummary.hide();
        this.ui.searchIcon.show();
        window.MapService.events.trigger('map:search:start', query);
    },

    serializeData: function() {
        return {
            MAX_RESULTS: this.MAX_RESULTS,
            filter: window.MapService.filter
        };
    },

    showResults: function() {
        this.ui.results.empty();
        this.ui.searchIcon.hide();

        if (window.MapService.filter === '') {
            this.showSummary(this.collection.length);
            return;
        }

        const siteIds = [...window.MapService.siteIds];
        this.showSummary(siteIds.length);

        for (let i = 0; i < siteIds.length && i < this.MAX_RESULTS; i++) {
            const site = this.collection.get(siteIds[i]);
            this.ui.results.append(JST['templates/ui/map/result']({
                address: site.get('address').full_address,
                href: site.nodeUrl(),
                name: site.get('name'),
                tags: site.tagNames().join(', ')
            }));
        }
    },

    showSummary: function(length) {
        let i18key = length === 1 ? 'glossary.site' : 'glossary.sites';
        this.ui.searchSummary.html(`${length} ${i18next.t(i18key)}`).show();
    }
});
